/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_poi_category_settings__not_available = /** @type {(inputs: {}) => string} */ () => {
	return `Sonderziele können auf dieser Seite nicht angezeigt werden.`
};

const en_poi_category_settings__not_available = /** @type {(inputs: {}) => string} */ () => {
	return `Points of interest cannot be displayed on this page.`
};

const es_poi_category_settings__not_available = /** @type {(inputs: {}) => string} */ () => {
	return `Los puntos de interés no pueden mostrarse en esta página.`
};

const fr_poi_category_settings__not_available = /** @type {(inputs: {}) => string} */ () => {
	return `Les points d’intérêt ne peuvent pas être affichés sur cette page.`
};

const it_poi_category_settings__not_available = /** @type {(inputs: {}) => string} */ () => {
	return `I punti di interesse non possono essere visualizzati in questa pagina.`
};

const nl_poi_category_settings__not_available = /** @type {(inputs: {}) => string} */ () => {
	return `Nuttige punten kunnen niet worden weergegeven op deze pagina.`
};

const pt_poi_category_settings__not_available = /** @type {(inputs: {}) => string} */ () => {
	return `Os pontos de interesse não podem ser apresentados nesta página.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__not_available = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.poi_category_settings__not_available(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("poi_category_settings__not_available", locale)
	if (locale === "de") return de_poi_category_settings__not_available(inputs)
	if (locale === "en") return en_poi_category_settings__not_available(inputs)
	if (locale === "es") return es_poi_category_settings__not_available(inputs)
	if (locale === "fr") return fr_poi_category_settings__not_available(inputs)
	if (locale === "it") return it_poi_category_settings__not_available(inputs)
	if (locale === "nl") return nl_poi_category_settings__not_available(inputs)
	return pt_poi_category_settings__not_available(inputs)
};